import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { deleteCountry, getAllCountries,createCountry,editCountry} from '../../api/axiosCountries';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import DeleteDialog from '../../components/dialogs/DeleteDialog';
import { Dialog } from 'primereact/dialog';
import ReactCountryFlag from "react-country-flag";
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import TableActions from '../../components/buttonActions/TableActions';









const Countries = () => {
  const { countries, setCountries, setFetcherror } = useContext(DataContext);
 
  const toast = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [addItemeDialogVisible, setAddItemDialogVisible] = useState(false);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  
  const [selectedId, setSelectedId] = useState(); //Track Id for Deleting or Editing
  
  const [countryName, setCountryName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [editedCountryName, setEditedCountryName] = useState("");
  const [editedCountryCode, setEditedCountryCode] = useState("");



  const NewTitle = "All Countries";
  useEffect(() => {
    
    getAllCountries(setCountries, setFetcherror);
    
  }, []);


  const filteredCountries = countries.filter((item) => item.name.toLowerCase().includes(globalFilter.toLowerCase()) || item.code.toLowerCase().includes(globalFilter.toLowerCase()));
  const filteredReversedCountries = filteredCountries.reverse();
  
  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  // Delete Dialogue
  const deletefunction = (pkid, setCountries, setFetcherror, handleAllToasts) => {
    return () => {
      deleteCountry(pkid, setCountries, setFetcherror, handleAllToasts);
    };
  };
  const deletedialogHeader = "Confirm Delete";
  const deletedialogContents = (
      <p>Do you really want to delete this Country?, Click "Yes" to Proceed or "No" to Cancel</p>
  );

  const getItemtoEdit = (pkid, items) => {
    const foundItem = items.find((item) => item.id === pkid);
    setEditedCountryName(foundItem?.name);
    setEditedCountryCode(foundItem?.code);
   }

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={ NewTitle}>
        <SearchToolBar
            setAddItemDialogVisible={setAddItemDialogVisible}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            searchPlaceholder="Coutries"
            createLabel="Country"
          />
        
        <DataTable
          value={filteredCountries}
          showGridlines
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 20]}
          emptyMessage="No countries found"
        >
                    <Column header="S/N" body={(rowData) => countries.indexOf(rowData)+1 } sortable> </Column>
                    <Column header="Country"   body={(rowData) => rowData.name} sortable></Column>
                    <Column header="Flag" body={(rowData) => (
                             
                              <ReactCountryFlag
                                countryCode={rowData.code}
                                style={{
                                  fontSize: "2em",
                                  marginLeft: "5px",
                                  padding: "0",
                                  cursor: "pointer"
                                }}
                              />)
                        } sortable></Column>
                    <Column header="Actions" body={(rowData) => (
                            
                            <TableActions
                              id={rowData.id}
                              data={countries}
                              getItemtoEdit={getItemtoEdit}
                              setSelectedId={setSelectedId}
                              setEditDialogVisible={setEditDialogVisible}
                              setDeleteDialogVisible={ setDeleteDialogVisible}
                          />
                        
                          )}>
                    </Column>
        </DataTable>

      
        
        {addItemeDialogVisible &&
          
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="New Country" visible={addItemeDialogVisible} style={{ width: '25vw' }} onHide={() => setAddItemDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                createCountry(countryName, setCountryName, countryCode, setCountryCode, setFetcherror, handleAllToasts, setCountries);
                if (countryName && countryCode) { setAddItemDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Country Name"
                    value={countryName}
                    onChange={(e) => setCountryName(e.target.value)}
                  />

                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Country Description"
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    />
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setAddItemDialogVisible(false); setCountryName(""); setCountryCode("") }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }
        



        {
          editDialogVisible &&
          <div className="card flex justify-content-center">
          <Dialog className='-mt-8' header="Edit Country" visible={editDialogVisible} style={{ width: '25vw' }} onHide={() => setEditDialogVisible(false)} >
              <form onSubmit={(e) => { 
                e.preventDefault();
                editCountry( selectedId, editedCountryName, setEditedCountryName, editedCountryCode, setEditedCountryCode, setFetcherror, handleAllToasts, setCountries);
                if (editedCountryName || editedCountryCode) { setEditDialogVisible(false); }
              }}>
                  <InputText
                    className='w-full mb-4'
                    type="text"
                    // disabled
                    placeholder="Enter Country Name"
                    value={editedCountryName}
                    onChange={(e) => setEditedCountryName(e.target.value)}
                  />

                  <InputText
                    className='w-full mb-4'
                    type="text"
                    placeholder="Enter Country Description"
                    value={editedCountryCode}
                    onChange={(e) => setEditedCountryCode(e.target.value)}
                    />
                 <div  className="card flex justify-content-end">
                  <Button label="Cancel" icon="pi pi-times" onClick={() => { setEditDialogVisible(false); setCountryName(""); setCountryCode("") }} className="p-button-text px-3 py-1 text-sm" />
                  <Button type='submit' label="Save" icon="pi pi-check"  autoFocus  className="px-3 py-1 text-sm"/>
                </div>
            </form>
          </Dialog>
         </div>
        
        }

        
        
        {
                deleteDialogVisible &&
        
                <DeleteDialog
                    dilogvisible={deleteDialogVisible}
                    setDilogvisibleVisible={setDeleteDialogVisible}
                    deletefucton={deletefunction(selectedId, setCountries, setFetcherror, handleAllToasts)}
                    dialogHeader={deletedialogHeader}
                    dialogContents={ deletedialogContents}
                    
                 />
      } 
       
                
      </Card>
      
    </div>
  )
}

export default Countries